function CalculatorIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8333 2.5H4.16667C3.25 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5ZM15.8333 15.8333H4.16667V4.16667H15.8333V15.8333Z"
        fill="currentColor"
      />
      <path
        d="M9.37492 6.43359H5.20825V7.6836H9.37492V6.43359Z"
        fill="currentColor"
      />
      <path
        d="M14.9999 13.125H10.8333V14.375H14.9999V13.125Z"
        fill="currentColor"
      />
      <path
        d="M14.9999 11.041H10.8333V12.291H14.9999V11.041Z"
        fill="currentColor"
      />
      <path
        d="M6.66667 14.9993H7.91667V13.3327H9.58333V12.0827H7.91667V10.416H6.66667V12.0827H5V13.3327H6.66667V14.9993Z"
        fill="currentColor"
      />
      <path
        d="M11.7417 9.125L12.9167 7.95L14.0917 9.125L14.9751 8.24167L13.8001 7.05833L14.9751 5.88333L14.0917 5L12.9167 6.175L11.7417 5L10.8584 5.88333L12.0334 7.05833L10.8584 8.24167L11.7417 9.125Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default CalculatorIcon;
